import { CookieOptions } from 'express';
import Cookies, { Cookie, CookieSetOptions } from 'universal-cookie';
////////////////
//////////////////////////////////////////////////////////////////////////
//////////

function getCookies() {
  let cookies;
//////////////////
///////////////////////////
////////////////////////////////////////////////////////////
///////////
  cookies = new Cookies();
////////////
  return cookies;
}

export default {
  get(name: string) {
    const cookies = getCookies();
    return Reflect.apply(cookies.get, cookies, [name]);
  },

  set(name: string, value: Cookie, options?: CookieSetOptions) {
    const cookies = getCookies();
    Reflect.apply(cookies.set, cookies, arguments);

////////////////////
//////////////////////
////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////
/////////////////////////////
//////////////
///////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
/////
//////////////
  },

  delete(name: string) {
    const cookies = new Cookies();
    cookies.remove(name, { path: '/' });
  },
};
